import React from 'react';

import { Link } from 'react-router-dom';

import { t } from 'i18next';

import { Lock } from '@mui/icons-material';

import {
  Chip,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@datanomik/commons-ui';

type Props = {
  label: string;
  to: string | undefined;
  icon?: React.ReactNode;
  isSelected: boolean;
  isEnabled: boolean;
  isNew?: boolean;
  isBeta?: boolean;
  link?: string;
};

const SidebarMenuItem = ({
  label,
  to,
  icon,
  isSelected,
  isEnabled,
  isNew,
  isBeta,
  link,
}: Props) => {
  const target = link ? '_blank' : '';

  return (
    <ListItem sx={{ py: 0 }}>
      <ListItemButton
        selected={isSelected}
        disabled={!isEnabled}
        {...(link
          ? { component: 'a', href: link, target }
          : { component: Link, to })}
        sx={{ py: '7px' }}
      >
        {icon && <ListItemIcon>{icon}</ListItemIcon>}

        <ListItemText primary={t(label)} primaryTypographyProps={{ fontSize: '13px' }} />

        {!isEnabled && !isNew && !isBeta && (
          <ListItemIcon className="DnkListItemIcon-lock">
            <Lock className="dn-menu-icon-lock" />
          </ListItemIcon>
        )}

        {isNew && (
          <Chip
            label={t('New')}
            sx={{ backgroundColor: 'teal.light', color: 'teal.darker' }}
          />
        )}

        {isBeta && (
          <Chip
            label="Beta"
            sx={{ backgroundColor: 'warning.lighter', color: 'warning.darker' }}
          />
        )}
      </ListItemButton>
    </ListItem>
  );
};

export default SidebarMenuItem;
